import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { FormWrapper, Label, Button, Input } from './shared_form_styles';
import { login } from '../actions/usersActions';
import LoadingSpinner from '../components/LoadingSpinner';
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Popup = styled.div`
  background-color: white;
  padding: 5%;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
`;
const LoginTitle = styled.h4`
  font-size:2.5em;
  align-self:flex-start;
  color: var(--primary-color) !important;
  padding:4px 0;
  margin: 5px 0;
`;


function LoginPopup({ onLoginSuccess }) {
    const [mail, setMail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [processing, setProcessing] = useState(false);
    const dispatch = useDispatch();

    const handleLogin = async (event) => {
        event.preventDefault();
        setProcessing(true);
        const userInfo = { mail, password };
        await dispatch(login(userInfo));
        const token = await localStorage.getItem('token');
        setProcessing(false);

        if (token) {
            localStorage.setItem('token', token);
            onLoginSuccess();
        } else {
            setMessage('El usuario y/o la contraseña no son correctos');
        }
    };



    if (processing ) {
        return <LoadingSpinner />;
      }

    return (
        <Overlay>
            <Popup>
                <LoginTitle>Login</LoginTitle>
                <FormWrapper style={{gap:"10px"}}>
                    <Input
                        type="text"
                        value={mail}
                        onChange={(e) => setMail(e.target.value)}
                        placeholder="Mail"
                        required
                    />
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                    />
                    <Button onClick={handleLogin}>Login</Button>
                </FormWrapper>
                <p style={{color:"red"}}>{message}</p>
            
                <p style={{color:"gray"}}>user:test pass:test</p>
            </Popup>
        </Overlay>
    );
}


export default LoginPopup;
